/* stellar-compra-pdp.js — Raio-X G2-8 (01/10).
   Era o <script> inline de sections/stellar-pro-compra.liquid (45 KB, sem
   Liquid dentro). Como arquivo, fica em cache entre as PDPs e sai do HTML.
   Carrega com defer: roda depois que a pagina inteira foi lida, antes do
   DOMContentLoaded. O conteudo e o mesmo, sem nenhuma alteracao. No editor
   de temas, quando a secao e recarregada, ele roda de novo (como o inline). */
(function () {
  function iniciar() {
(function () {
  var caixa = document.querySelector('.spdp .buy.cpr');
  if (!caixa || caixa.dataset.cprPronto) return;
  caixa.dataset.cprPronto = '1';

  /* ══════════════════════════════════════════════════════════════════
     O CUPOM DA SACOLA, DITO AQUI — 16/08.

     REGRA DE OURO: so mexe no preco quando da pra PROVAR o numero.
     Medi os cupons da loja e existem tres situacoes bem diferentes:

     1. O produto JA esta na sacola.
        `final_line_price / original_line_price` e a conta que a propria
        Shopify fez. Nao ha o que estimar — vale qualquer cupom, de
        qualquer classe.

     2. O produto NAO esta na sacola, e o cupom e de PEDIDO em
        porcentagem valendo pra tudo (`target_selection: 'all'`).
        Medido: SOUFUNDADOR volta como value 10.0, value_type
        percentage, selection all. Uma porcentagem sobre o pedido inteiro
        e a mesma porcentagem sobre cada item — a conta fecha sozinha.

     3. Qualquer outra coisa — cupom de PRODUTO com o produto fora da
        sacola, ou desconto de valor fixo, que a Shopify rateia entre os
        itens e portanto depende do que mais tem no carrinho.
        Aqui o preco NAO muda. Dos 100 primeiros cupons ativos da loja,
        86 sao de produto: chutar aqui seria anunciar desconto que a
        maioria dos codigos nao da neste item. O selo aparece dizendo
        "desconto no checkout", que e verdade em todos os casos.
     ══════════════════════════════════════════════════════════════════ */
  (function cupomDaSacola() {
    var selo = caixa.querySelector('[data-cpr-cupom]');
    if (!selo || !window.fetch) return;
    var elCod = selo.querySelector('[data-cpr-cupom-cod]');
    var elFim = selo.querySelector('[data-cpr-cupom-fim]');
    var pid = parseInt(caixa.getAttribute('data-produto') || '0', 10);

    var MOEDA = /R\$\s?\d{1,3}(?:\.\d{3})*,\d{2}/g;
    function paraNumero(t) {
      return parseFloat(String(t).replace(/[^\d,]/g, '').replace(/\./g, '').replace(',', '.'));
    }
    function paraTexto(v) {
      return 'R$ ' + v.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }
    /* Reescreve so os NOS DE TEXTO: assim o <small>sem juros</small> e
       qualquer outra marcacao dentro da linha ficam intactos.

       E pula tudo que estiver dentro de `.cpr-de` — aquele e o preco ANCORA,
       o "de" que a pagina mostra riscado. Ele nao e o que a pessoa vai pagar
       e portanto nao recebe desconto: descontar a ancora encolheria a
       propria comparacao que ela existe pra fazer. */
    function dentroDaAncora(no) {
      for (var e = no.parentNode; e && e !== caixa; e = e.parentNode) {
        if (e.classList && (e.classList.contains('cpr-de') || e.classList.contains('cpr-antes'))) return true;
      }
      return false;
    }
    function reescrever(el, fator) {
      if (!el) return 0;
      var quantos = 0;
      var passo = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
      var nos = [], n;
      while ((n = passo.nextNode())) nos.push(n);
      nos.forEach(function (no) {
        if (dentroDaAncora(no)) return;
        MOEDA.lastIndex = 0;
        if (!MOEDA.test(no.nodeValue)) return;
        MOEDA.lastIndex = 0;
        no.nodeValue = no.nodeValue.replace(MOEDA, function (achado) {
          var v = paraNumero(achado);
          if (!(v > 0)) return achado;
          quantos++;
          return paraTexto(Math.round(v * fator * 100) / 100);
        });
      });
      return quantos;
    }

    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (!c) return;
        var cod = (c.discount_codes || []).filter(function (d) { return d.applicable; })[0];
        if (!cod) return;
        if (elCod) elCod.textContent = cod.code;

        /* OS DOIS NIVEIS SE MULTIPLICAM, nao se escolhem.
           Medido na loja: com KIT (item) + SOUFUNDADOR (pedido), a Shopify
           tira os 10% do pedido do subtotal QUE JA VEIO com o KIT abatido —
           519.997 − 10.000 = 509.997, e 10% disso = 50.999, que e exatamente
           o que ela cobrou. Ou seja, os fatores se compoem.

           Foi por isso que a primeira versao errou: com o produto na sacola
           e um cupom de PEDIDO, `final_line_price` volta IGUAL ao cheio (o
           abatimento do pedido nao desce pra linha), o fator de item dava 1
           e o codigo parava ali, sem nunca olhar o nivel de pedido. */
        var fator = 1, achei = false;
        (c.items || []).some(function (it) {
          if (it.product_id !== pid || !(it.original_line_price > 0)) return false;
          var f = it.final_line_price / it.original_line_price;
          if (f > 0 && f < 1) { fator *= f; achei = true; }
          return true;
        });
        var d = (c.cart_level_discount_applications || []).filter(function (x) {
          return x.type === 'discount_code' && x.value_type === 'percentage' && x.target_selection === 'all';
        })[0];
        if (d) {
          var pc = parseFloat(d.value);
          if (pc > 0 && pc < 100) { fator *= (1 - pc / 100); achei = true; }
        }

        var mexeu = false;
        if (achei && fator > 0 && fator < 1) {
          var n = reescrever(caixa.querySelector('.cpr-val'), fator);
          n += reescrever(caixa.querySelector('.cpr-parc'), fator);
          mexeu = n > 0;
        }
        /* O riscado nao e reescrito aqui de proposito: a pagina JA mostra o
           preco ancora riscado (`preco_de`). Um segundo numero cortado do
           lado seria duas comparacoes competindo pela mesma frase. */
        if (elFim) elFim.textContent = mexeu ? 'já está no preço abaixo' : 'aplicado · desconto no checkout';
        selo.hidden = false;
      })
      .catch(function () {});
  })();

  /* ── A VOLTAGEM DESTRAVA O BOTAO ────────────────────────────────────────
     Nada vem escolhido de proposito: comprar a tomada errada e o erro mais
     caro desta pagina. Enquanto ninguem escolhe, o botao fica apagado — mas
     continua do mesmo tamanho e no mesmo lugar, pra ficar claro que ele
     existe e que falta um passo. O compartilhar NAO trava junto: ele nao
     depende de escolha nenhuma. */
  var volt = document.getElementById('volt');
  if (volt) {
    var eco = caixa.querySelector('[data-volt-eco]');
    var botao = caixa.querySelector('[data-comprar]');
    var pista = caixa.querySelector('[data-pista]');
    /* A cor entra na coluna colada na voltagem: as duas sao a mesma pergunta,
       uma atras da outra. Copiando o `order` da voltagem, o empate e desfeito
       pelo HTML — e a cor, que vem antes no markup, cai logo acima dela em
       qualquer largura, sem eu adivinhar numero de uma folha que nao leio. */
    var cprCor = caixa.querySelector('.cpr-cor--escolha');
    var cprVolt = caixa.querySelector('.cpr-passo.cpr-volt');
    if (cprCor && cprVolt) {
      var cprVagaCor = function () {
        var o = getComputedStyle(cprVolt).order;
        if (o && o !== 'auto') { cprCor.style.order = o; }

        /* A REDE, E POR QUE ELA EXISTE — 08/09.

           A regra de CSS acima foi testada em bancada contra seis formas
           plausiveis da regra que esconde o passo no `stellar-pro.css`. Ela
           ganha de quatro. Perde de duas: seletor com id e `!important`. E eu
           NAO consigo ler aquele arquivo pra saber qual das seis e a
           verdadeira — 205 KB entregues por URL assinada num CDN que este
           ambiente nao alcanca.

           Entao em vez de escalar `!important` na folha inteira — que e como
           se ganha uma briga de especificidade e se perde a proxima — a
           checagem acontece depois de tudo carregado e so age se o defeito
           AINDA estiver la. Estilo inline com prioridade bate qualquer regra
           de folha, e este so existe quando ha mais de uma cor: a pagina do
           PRO nunca chega nesta linha.

           No dia em que alguem puder abrir o `stellar-pro.css` e consertar a
           origem, esta rede pode sair. Ate la ela e o que garante que a
           pessoa consegue escolher entre o rosa e o verde. */
        if (getComputedStyle(cprCor).display === 'none') {
          cprCor.style.setProperty('display', 'block', 'important');
        }
      };
      cprVagaCor();
      addEventListener('resize', cprVagaCor, { passive: true });
      addEventListener('load', cprVagaCor);
    }

    var cprResta = caixa.querySelector('[data-resta-linha]');
    var cprRestaTx = cprResta ? cprResta.querySelector('[data-resta-tx]') : null;
    if (cprResta && !cprRestaTx) { cprResta = null; }
    volt.querySelectorAll('.cpr-esc').forEach(function (b, i) {
      b.addEventListener('click', function () {
        volt.classList.add('escolhido');
        volt.classList.toggle('segunda', i === 1);
        if (eco) eco.textContent = ', ' + (b.getAttribute('data-volt') || '').trim();
        if (botao) { botao.classList.remove('travado'); botao.removeAttribute('aria-disabled'); }
        if (pista) pista.classList.add('some');

        /* o contador acende no clique porque e o clique que define de QUAL
           saldo estamos falando. Acima do limiar ele volta a se esconder. */
        if (cprResta) {
          var n = parseInt(b.getAttribute('data-resta') || '', 10);
          var lim = parseInt(cprResta.getAttribute('data-limiar') || '10', 10);
          if (n > 0 && n <= lim) {
            var molde = n === 1
              ? (cprResta.getAttribute('data-frase1') || '')
              : (cprResta.getAttribute('data-frase') || '');
            cprRestaTx.textContent = molde
              .replace('{n}', n)
              .replace('{v}', (b.getAttribute('data-volt') || '').trim());
            cprResta.hidden = false;
          } else {
            cprResta.hidden = true;
          }
        }

        /* a escolha vale pra tudo que depende dela: o que entra na sacola e o
           que a Shopify cota de frete. Sem repassar aqui, o switch mudava a
           cor do desenho e o pedido continuava saindo com a primeira. */
        var vid = b.getAttribute('data-variante');
        if (vid) {
          if (botao) botao.setAttribute('data-variante', vid);
          var fr = caixa.querySelector('[data-frete]');
          if (fr) fr.setAttribute('data-variante', vid);
        }
      });
    });
    if (botao) {
      botao.addEventListener('click', function (e) {
        if (botao.classList.contains('travado')) {
          e.preventDefault();
          /* em vez de so bloquear, leva o olho pro que falta */
          volt.scrollIntoView({ behavior: 'smooth', block: 'center' });
          volt.classList.add('pisca');
          setTimeout(function () { volt.classList.remove('pisca'); }, 1200);
        }
      });
    }
  }

  /* ── ADICIONAR A SACOLA ─────────────────────────────────────────────────
     O DONO DO CARRINHO CONTINUA SENDO O CABECALHO.

     Ele publica `window.StellarSacola` com `secao`, `repintar` e `abrir`.
     Aqui eu so faço a chamada e entrego o HTML pronto pra ele — quem troca o
     conteudo do painel e acerta o contador e sempre o mesmo codigo, tanto
     faz se o toque veio do "+" da sacola ou deste botao. Se o cabecalho nao
     estiver na pagina (ou for uma versao antiga), o plano B e ir pra
     /cart: perder a animacao e melhor que perder a compra.

     O GESTO NAO ESPERA A REDE — igual ao botao da sacola. A confirmacao
     dispara no clique e a chamada corre por baixo; se der errado, desfaz.
     O selo tem tempo minimo de tela: se a resposta voltar antes, ela espera
     o gesto terminar; se voltar depois, nao espera nada a mais. */
  var add = caixa.querySelector('button[data-comprar]');
  if (add) {
    var MINIMO = 620;
    add.addEventListener('click', function () {
      if (add.classList.contains('travado') || add.dataset.ocupado === 'sim') return;
      add.dataset.ocupado = 'sim';

      var ponte = window.StellarSacola || null;
      var t0 = (window.performance && performance.now) ? performance.now() : Date.now();
      function decorrido() {
        return ((window.performance && performance.now) ? performance.now() : Date.now()) - t0;
      }

      add.classList.add('feito');
      voar();

      var corpo = { items: [{ id: parseInt(add.getAttribute('data-variante'), 10), quantity: 1 }] };
      /* O ACRESCIMO VIAJA NO MESMO PEDIDO.
         Um `items` com dois objetos, nao duas chamadas: uma chamada so quer
         dizer que ou os dois entram ou nenhum entra. Com duas, um erro de
         rede no meio deixaria o carrinho com metade do que a pessoa marcou —
         e ela so descobriria no checkout. O secador vem primeiro de
         proposito: e ele que manda na sacola e no desconto. */
      var acr = caixa.querySelector('[data-acr-cx]');
      if (acr && acr.checked && acr.value) {
        corpo.items.push({ id: parseInt(acr.value, 10), quantity: 1 });
      }
      if (ponte && ponte.secao) {
        corpo.sections = ponte.secao;
        corpo.sections_url = location.pathname + location.search;
      }

      fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(corpo)
      })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function (d) {
          var falta = MINIMO - decorrido();
          return new Promise(function (ok) { setTimeout(function () { ok(d); }, falta > 0 ? falta : 0); });
        })
        .then(function (d) {
          if (!ponte || !ponte.refrescar) { location.href = '/cart'; return; }
          /* `sections` pode voltar nulo mesmo com o id certo no pedido — na
             previa do tema volta sempre. O cabecalho sabe se virar sem ele. */
          var html = d && d.sections && d.sections[ponte.secao];
          return Promise.resolve(ponte.refrescar(html)).then(function () {
            ponte.abrir();
            setTimeout(function () {
              add.classList.remove('feito');
              add.dataset.ocupado = '';
            }, 900);
          });
        })
        .catch(function () {
          add.classList.remove('feito');
          add.dataset.ocupado = '';
          location.href = '/cart';
        });
    });
  }

  /* A FOTO VAI PRA SACOLA.

     Um clone da foto que esta na tela encolhe ate o icone da sacola no
     cabecalho. E o unico jeito de o toque, que acontece no meio da pagina,
     apontar pra onde a coisa foi parar — o icone fica fora do campo de visao
     de quem esta olhando o botao. Se nao houver foto ou nao houver icone, a
     funcao desiste em silencio: e enfeite, nao etapa. */
  function voar() {
    if (window.matchMedia('(prefers-reduced-motion:reduce)').matches) return;
    var pista = document.getElementById('galtrack');
    var origem = null;
    if (pista && pista.children.length && getComputedStyle(pista).display !== 'contents') {
      var meio = pista.getBoundingClientRect().left + pista.clientWidth / 2, menor = Infinity;
      [].forEach.call(pista.children, function (f) {
        var r = f.getBoundingClientRect(), d = Math.abs(r.left + r.width / 2 - meio);
        if (d < menor) { menor = d; origem = f; }
      });
    }
    if (!origem) origem = document.getElementById('galmain');
    var alvo = document.querySelector('[data-sth-sacola]');
    if (!origem || !alvo || !origem.src) return;

    var de = origem.getBoundingClientRect(), pra = alvo.getBoundingClientRect();
    if (!de.width || !pra.width) return;

    var voo = document.createElement('img');
    voo.src = origem.src;
    voo.className = 'cpr-voo';
    voo.style.left = de.left + 'px';
    voo.style.top = de.top + 'px';
    voo.style.width = de.width + 'px';
    voo.style.height = de.height + 'px';
    document.body.appendChild(voo);

    var dx = (pra.left + pra.width / 2) - (de.left + de.width / 2);
    var dy = (pra.top + pra.height / 2) - (de.top + de.height / 2);
    requestAnimationFrame(function () {
      voo.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(.06)';
      voo.style.opacity = '.15';
    });
    setTimeout(function () { voo.remove(); }, 780);
  }

  /* ── OS MINI CARDS QUE VIRAM ────────────────────────────────────────────
     So um fica virado por vez: dois videos tocando lado a lado num trilho de
     100px cada e ruido, nao informacao. O video so comeca quando o card
     vira e para quando ele volta — preload="none" garante que nada e baixado
     de quem nunca tocou. */
  var cards = [].slice.call(caixa.querySelectorAll('[data-virar]'));
  cards.forEach(function (c) {
    c.addEventListener('click', function () {
      var abrindo = !c.classList.contains('virado');
      cards.forEach(function (o) {
        if (o === c) return;
        o.classList.remove('virado');
        o.setAttribute('aria-pressed', 'false');
        var vo = o.querySelector('video');
        if (vo) { vo.pause(); }
      });
      c.classList.toggle('virado', abrindo);
      c.setAttribute('aria-pressed', abrindo ? 'true' : 'false');
      var v = c.querySelector('video');
      if (!v) return;
      if (abrindo) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      else { v.pause(); v.currentTime = 0; }
    });
  });

  /* ── A DUVIDA DA VOLTAGEM ─────────────────────────────────────────────── */
  caixa.querySelectorAll('[data-duvida] > button').forEach(function (b) {
    b.addEventListener('click', function () {
      var d = b.parentNode, abriu = !d.classList.contains('aberta');
      d.classList.toggle('aberta', abriu);
      b.setAttribute('aria-expanded', abriu ? 'true' : 'false');
    });
  });

  /* ── COMPARTILHAR ─────────────────────────────────────────────────────── */
  var share = caixa.querySelector('[data-share]');
  if (share) {
    share.addEventListener('click', function () {
      var dados = { title: document.title, url: location.href };
      if (navigator.share) { navigator.share(dados).catch(function () {}); return; }
      if (navigator.clipboard) {
        navigator.clipboard.writeText(location.href).then(function () {
          share.classList.add('copiado');
          setTimeout(function () { share.classList.remove('copiado'); }, 1600);
        });
      }
    });
  }

  /* ── FRETE ──────────────────────────────────────────────────────────────
     Sem backend e sem token: quem cota e a propria Shopify, com as
     transportadoras contratadas na conta.

     Duas coisas nao obvias que o codigo precisa fazer:

     1. A cotacao exige o ESTADO, nao so o CEP. A UF vem do ViaCEP antes de
        chamar a Shopify — e um CEP que o ViaCEP nao conhece ja para aqui,
        antes de mexer no carrinho.
     2. So da pra cotar o que esta no CARRINHO INTEIRO. Entao a sacola e
        fotografada, esvaziada para conter apenas este item, cotada, e
        refeita em seguida — no sucesso e no erro. Sem isso, quem ja tinha
        outros produtos na sacola recebia o frete da soma de todos eles. */
  var frete = caixa.querySelector('[data-frete]');
  if (!frete) return;

  var campo = frete.querySelector('[data-frete-input]'),
      irBt  = frete.querySelector('[data-frete-ir]'),
      linha = frete.querySelector('[data-frete-campo]'),
      load  = frete.querySelector('[data-frete-load]'),
      res   = frete.querySelector('[data-frete-res]'),
      erro  = frete.querySelector('[data-frete-erro]'),
      ajuda = frete.querySelector('[data-frete-ajuda]'),
      cabCep = frete.querySelector('[data-frete-cep]'),
      trocar = frete.querySelector('[data-frete-trocar]'),
      pergunta = cabCep ? cabCep.textContent : '',
      rodape = frete.getAttribute('data-rodape') || '',
      unidade = frete.getAttribute('data-unidade') || '';

  /* ABRIR E FECHAR

     `abrir()` e chamado de tres lugares: o toque no cabecalho, o "trocar cep"
     e o proprio `calcular()`. Esse terceiro nao e paranoia — o botao de
     calcular so existe dentro do corpo, mas o Enter no campo e um resultado
     que chega depois de alguem ter fechado a gaveta no meio da espera
     tambem passam por ali, e uma resposta escondida e pior que resposta
     nenhuma.

     O foco no campo so acontece quando o gesto foi de abrir: chamar focus()
     junto de um resultado que chega sozinho abriria o teclado do celular por
     cima da resposta que a pessoa acabou de pedir. */
  var abre = frete.querySelector('[data-frete-abrir]');
  function abrir(comFoco) {
    frete.classList.add('aberto');
    if (abre) abre.setAttribute('aria-expanded', 'true');
    if (comFoco) campo.focus();
  }
  if (abre) {
    abre.addEventListener('click', function () {
      if (frete.classList.contains('aberto')) {
        frete.classList.remove('aberto');
        abre.setAttribute('aria-expanded', 'false');
      } else {
        abrir(true);
      }
    });
  }

  function digitos() { return campo.value.replace(/\D/g, '').slice(0, 8); }

  campo.addEventListener('input', function () {
    var d = digitos();
    campo.value = d.length > 5 ? d.slice(0, 5) + '-' + d.slice(5) : d;
    irBt.disabled = d.length !== 8;
    erro.hidden = true;
  });
  campo.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') { e.preventDefault(); if (!irBt.disabled) calcular(); }
  });
  irBt.addEventListener('click', calcular);
  if (trocar) {
    trocar.addEventListener('click', function () {
      res.hidden = true; trocar.hidden = true; linha.hidden = false;
      if (ajuda) ajuda.hidden = false;
      if (cabCep) cabCep.textContent = pergunta;
      abrir(true);
    });
  }

  /* ATENCAO: aqui o preco vem em REAIS, nao em centavos. O resto da AJAX API
     da Shopify (/cart.js, line_items) trabalha em centavos, e por isso o
     dividir por 100 parece certo e passa despercebido — mas
     async_shipping_rates devolve `price` como texto decimal ("66.14"). Com a
     divisao, um PAC de R$ 66,14 aparecia como R$ 0,66. */
  function dinheiro(valorEmReais) {
    return Number(valorEmReais).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }
  function espera(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  /* A cotacao da Shopify exige o ESTADO, nao so o CEP. A faixa de CEP por UF
     e fixa e publica — entao ela vive aqui como rede de seguranca pra quando
     o ViaCEP nao responder. Cada par e [inicio, fim] dos cinco primeiros
     digitos. Fonte: plano de numeracao dos Correios. */
  var FAIXAS = [
    [1000, 19999, 'SP'], [20000, 28999, 'RJ'], [29000, 29999, 'ES'], [30000, 39999, 'MG'],
    [40000, 48999, 'BA'], [49000, 49999, 'SE'], [50000, 56999, 'PE'], [57000, 57999, 'AL'],
    [58000, 58999, 'PB'], [59000, 59999, 'RN'], [60000, 63999, 'CE'], [64000, 64999, 'PI'],
    [65000, 65999, 'MA'], [66000, 68899, 'PA'], [68900, 68999, 'AP'], [69000, 69299, 'AM'],
    [69300, 69399, 'RR'], [69400, 69899, 'AM'], [69900, 69999, 'AC'], [70000, 72799, 'DF'],
    [72800, 72999, 'GO'], [73000, 73699, 'DF'], [73700, 76799, 'GO'], [76800, 76999, 'RO'],
    [77000, 77999, 'TO'], [78000, 78899, 'MT'], [79000, 79999, 'MS'], [80000, 87999, 'PR'],
    [88000, 89999, 'SC'], [90000, 99999, 'RS']
  ];
  function ufPelaFaixa(cep) {
    var n = parseInt(cep.slice(0, 5), 10);
    if (!(n > 0)) return '';
    for (var i = 0; i < FAIXAS.length; i++) {
      if (n >= FAIXAS[i][0] && n <= FAIXAS[i][1]) return FAIXAS[i][2];
    }
    return '';
  }
  function postar(url, corpo) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(corpo)
    });
  }
  function variante() {
    var u = new URLSearchParams(location.search).get('variant');
    return u || frete.getAttribute('data-variante');
  }

  /* A SACOLA INTEIRA PRECISA SAIR DE CENA DURANTE A COTACAO.
     A Shopify so sabe cotar o CARRINHO — nao existe endpoint que cote um
     item avulso. Antes, o item entrava na sacola e a cotacao saia pelo peso
     e pela cubagem de TUDO que ja estava la: quem tinha dois produtos no
     carrinho via o frete deste produto pela soma dos tres.

     A saida: fotografar a sacola, deixar so este item, cotar e devolver
     tudo. A foto tambem vai pro localStorage com a hora — se a pagina
     morrer no meio (aba fechada, 4G que cai), o proximo carregamento
     refaz a sacola sozinho. */
  var CHAVE_FOTO = 'stlFreteFoto';

  function fotografar(cart) {
    return (cart.items || []).map(function (it) {
      var l = { id: it.variant_id, quantity: it.quantity };
      if (it.properties && Object.keys(it.properties).length) l.properties = it.properties;
      if (it.selling_plan_allocation && it.selling_plan_allocation.selling_plan) {
        l.selling_plan = it.selling_plan_allocation.selling_plan.id;
      }
      return l;
    });
  }

  function guardarFoto(itens) {
    try { localStorage.setItem(CHAVE_FOTO, JSON.stringify({ quando: Date.now(), itens: itens })); } catch (e) {}
  }
  function esquecerFoto() {
    try { localStorage.removeItem(CHAVE_FOTO); } catch (e) {}
  }

  async function devolverSacola(itens) {
    await postar('/cart/clear.js', {});
    if (itens && itens.length) await postar('/cart/add.js', { items: itens });
    esquecerFoto();
    /* o contador do cabecalho nao adivinha: ou o painel se refaz sozinho,
       ou pelo menos o numerinho volta ao que era. */
    try {
      if (window.StellarSacola && window.StellarSacola.refrescar) window.StellarSacola.refrescar();
      else {
        var c = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: c }));
      }
    } catch (e) {}
  }

  /* ── A ENTREGA QUE A PESSOA JA CONSULTOU ────────────────────────────
     Depois de uma cotacao, sabemos duas coisas que valem em toda a loja: a
     CIDADE dela e o PRAZO do frete gratis ate la. Ficam no localStorage por
     sete dias — passado isso a tabela da transportadora pode ter mudado e
     um prazo velho vira promessa falsa.

     So guardamos com cidade. Sem ela a frase perde o unico motivo de
     existir, que e a pessoa se reconhecer no texto.

     Contrato (o cabecalho e a sacola leem a mesma chave):
       stlEntrega = { cep, cidade, uf, prazo, quando }   prazo em dias uteis */
  var CHAVE_ENTREGA = 'stlEntrega';
  var VALE_ENTREGA = 7 * 24 * 60 * 60 * 1000;

  function lerEntrega() {
    try {
      var g = JSON.parse(localStorage.getItem(CHAVE_ENTREGA) || 'null');
      if (!g || !g.cidade || !g.quando) return null;
      if (Date.now() - g.quando > VALE_ENTREGA) { localStorage.removeItem(CHAVE_ENTREGA); return null; }
      return g;
    } catch (e) { return null; }
  }

  function frasePrazo(dias) {
    return dias > 1 ? dias + ' dias úteis' : '1 dia útil';
  }

  function pintarEntrega() {
    var alvo = document.querySelector('[data-entrega]');
    if (!alvo) return;
    var g = lerEntrega();
    if (!g || !g.prazo) { alvo.hidden = true; return; }
    var molde = alvo.getAttribute('data-modelo') || '';
    /* Sem icone. O caminhao repetia em desenho o que a frase ja diz em
       palavra, e ficava logo acima do nome do produto — o primeiro grafico
       que o olho encontra na pagina era um caminhaozinho, nao o produto.
       A frase sozinha alinha com o titulo e some do caminho. */
    alvo.innerHTML = '<span></span>';
    alvo.querySelector('span').textContent =
      molde.replace('{cidade}', g.cidade).replace('{prazo}', frasePrazo(g.prazo));
    alvo.hidden = false;
  }
  pintarEntrega();

  /* REDE DE SEGURANCA. Se a cotacao anterior morreu no meio, a foto ainda
     esta guardada. Dez minutos de validade: passado isso a pessoa ja mexeu
     na sacola por conta propria e reescrever seria pior que o problema. */
  (function () {
    var cru = null;
    try { cru = localStorage.getItem(CHAVE_FOTO); } catch (e) { return; }
    if (!cru) return;
    try {
      var g = JSON.parse(cru);
      if (!g || !g.quando || (Date.now() - g.quando) > 600000) { esquecerFoto(); return; }
      devolverSacola(g.itens);
    } catch (e) { esquecerFoto(); }
  })();
  function mostrarErro(txt) {
    erro.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" ' +
      'stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7.5v5.5"/>' +
      '<circle cx="12" cy="16.4" r="1.1" fill="currentColor" stroke="none"/></svg><span>' + txt + '</span>';
    erro.hidden = false;
  }

  async function calcular() {
    var cep = digitos();
    if (cep.length !== 8) { mostrarErro('Faltam dígitos no CEP.'); return; }

    var vid = variante(), foto = null, mexeuNoCarrinho = false;
    abrir(false);
    erro.hidden = true; res.hidden = true;
    linha.hidden = true; if (ajuda) ajuda.hidden = true;
    load.hidden = false;
    if (cabCep) cabCep.textContent = campo.value;

    try {
      var uf = '', cidade = '', inexistente = false;
      try {
        /* 2,5s de teto: o ViaCEP e otimo mas e de terceiro. Se ele demorar
           ou cair, a tabela de faixas abaixo resolve sozinha e a pessoa nem
           percebe. So confiamos nele para dizer que um CEP NAO existe. */
        var corte = new AbortController();
        var relogio = setTimeout(function () { corte.abort(); }, 2500);
        var via = await fetch('https://viacep.com.br/ws/' + cep + '/json/', { signal: corte.signal })
          .then(function (r) { return r.json(); });
        clearTimeout(relogio);
        if (via && via.erro) inexistente = true;
        else if (via) { uf = via.uf || ''; cidade = via.localidade || ''; }
      } catch (e) {}

      if (!uf && !inexistente) uf = ufPelaFaixa(cep);

      if (!uf) {
        load.hidden = true; linha.hidden = false; if (ajuda) ajuda.hidden = false;
        if (cabCep) cabCep.textContent = pergunta;
        mostrarErro('Não encontramos esse CEP. Confira os números.');
        return;
      }

      var endereco = 'shipping_address%5Bzip%5D=' + encodeURIComponent(cep) +
                     '&shipping_address%5Bcountry%5D=Brazil' +
                     '&shipping_address%5Bprovince%5D=' + encodeURIComponent(uf);

      var carrinho = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
      foto = fotografar(carrinho);
      guardarFoto(foto);

      /* zera todas as linhas e deixa 1 deste produto. Uma chamada so:
         duas idas e vindas deixariam a sacola num estado intermediario
         visivel se a pessoa abrisse o painel no meio. */
      var zerar = {};
      foto.forEach(function (l) { zerar[l.id] = 0; });
      zerar[vid] = 1;
      mexeuNoCarrinho = true;
      await postar('/cart/update.js', { updates: zerar });
      await postar('/cart/prepare_shipping_rates.json?' + endereco, {});

      var tarifas = null;
      for (var i = 0; i < 12 && tarifas === null; i++) {
        await espera(600);
        var r = await fetch('/cart/async_shipping_rates.json?' + endereco, { headers: { 'Accept': 'application/json' } })
          .then(function (x) { return x.json(); });
        if (r && r.shipping_rates) tarifas = r.shipping_rates;
      }

      await devolverSacola(foto);
      mexeuNoCarrinho = false;

      load.hidden = true;

      if (!tarifas || !tarifas.length) {
        linha.hidden = false; if (ajuda) ajuda.hidden = false;
        if (cabCep) cabCep.textContent = pergunta;
        mostrarErro('Não encontramos frete para este CEP.');
        return;
      }

      var linhas = tarifas.map(function (t) {
        /* delivery_days ja vem em dias UTEIS, que e como a transportadora
           conta. Calcular pela data do delivery_range da dias corridos e
           inflava o prazo (5 uteis viravam 7). So caimos na conta por data
           quando a transportadora nao manda os dias. */
        var quando = '', dias = null;
        if (t.delivery_days && t.delivery_days.length) {
          dias = t.delivery_days[t.delivery_days.length - 1];
        } else if (t.delivery_range && t.delivery_range.length) {
          var fim = new Date(t.delivery_range[t.delivery_range.length - 1]);
          dias = Math.max(1, Math.ceil((fim - new Date()) / 86400000));
        }
        if (dias) quando = 'Chega em até ' + dias + (dias > 1 ? ' dias úteis' : ' dia útil');
        var gratis = Number(t.price) === 0;
        return '<div class="item"><div><div class="nome">' + t.name + '</div>' +
               (quando ? '<div class="quando">' + quando + '</div>' : '') + '</div>' +
               '<div class="preco' + (gratis ? ' gratis' : '') + '">' + (gratis ? 'Grátis' : dinheiro(t.price)) + '</div></div>';
      }).join('');

      /* O aviso de unidade vem ANTES do prazo de envio: ele explica os
         numeros que estao logo acima. O prazo e uma promessa de servico e
         pode vir depois. Se os dois estiverem vazios, o rodape nem existe. */
      var pe = '';
      if (unidade) pe += '<b>' + unidade + '</b>';
      if (rodape) pe += rodape;
      /* guarda a cidade e o prazo do frete GRATIS — e ele que a loja
         promete no cabecalho e na sacola, nao o PAC nem o Sedex. */
      if (cidade) {
        var gratis = null;
        for (var j = 0; j < tarifas.length; j++) {
          if (Number(tarifas[j].price) === 0) { gratis = tarifas[j]; break; }
        }
        var dg = null;
        if (gratis && gratis.delivery_days && gratis.delivery_days.length) {
          dg = gratis.delivery_days[gratis.delivery_days.length - 1];
        }
        if (dg) {
          try {
            localStorage.setItem(CHAVE_ENTREGA, JSON.stringify({
              cep: cep, cidade: cidade, uf: uf, prazo: dg, quando: Date.now()
            }));
          } catch (e) {}
          pintarEntrega();
          document.dispatchEvent(new CustomEvent('stellar:entrega'));
        }
      }

      res.innerHTML = linhas + (pe ? '<div class="pe">' + pe + '</div>' : '');
      res.hidden = false;
      if (trocar) trocar.hidden = false;
    } catch (e) {
      if (mexeuNoCarrinho) { try { await devolverSacola(foto); } catch (e2) {} }
      else esquecerFoto();
      load.hidden = true; linha.hidden = false; if (ajuda) ajuda.hidden = false;
      if (cabCep) cabCep.textContent = pergunta;
      mostrarErro('Não foi possível calcular agora. Tente de novo em instantes.');
    }
  }
  /* ── O ACRESCIMO TERMINA ONDE O BOTAO TERMINA ─────────────────────────
     O botao divide a linha com o circulo de compartilhar. O acrescimo e
     IRMAO dessa linha, nao filho — entao ele nasce com a largura da coluna
     inteira e sobra pra direita exatamente o tanto do circulo mais o vao.

     O recuo e a distancia da borda direita do BOTAO ate a borda direita da
     LINHA. Assim nao importa o que ha ali (circulo, nada, outra coisa), nem
     o diametro, nem o vao, nem se a linha e flex ou grade. Se o botao ocupa
     a linha toda — sem compartilhar, ou linha quebrada no celular estreito —
     da zero sozinho e nada muda. */
  var cprLinha = caixa.querySelector('.cpr-acoes');
  var cprAcr = caixa.querySelector('[data-acr]');
  var cprBtn = caixa.querySelector('[data-comprar]');
  if (cprLinha && cprAcr && cprBtn) {
    var cprMedirAltura = function () {
      cprAcr.style.setProperty('--cpr-alt', Math.round(cprBtn.getBoundingClientRect().height) + 'px');
    };
    cprMedirAltura();
    addEventListener('resize', cprMedirAltura, { passive: true });
    /* o botao muda de altura sem a janela mudar: fonte que carrega depois,
       rotulo que troca no "Adicionado", o proprio editor redesenhando. */
    if (window.ResizeObserver) new ResizeObserver(cprMedirAltura).observe(cprBtn);
  }

  /* ── FAIXA DE GARANTIAS: um detalhe aberto por vez ── */
  var garRaiz = caixa.querySelector('[data-cpr-gar]');
  if (garRaiz) {
    garRaiz.addEventListener('click', function (e) {
      var b = e.target.closest('[data-gar]');
      if (!b) return;
      var n = b.getAttribute('data-gar');
      var abrir = b.getAttribute('aria-expanded') !== 'true';
      garRaiz.querySelectorAll('[data-gar]').forEach(function (o) {
        o.setAttribute('aria-expanded', (abrir && o === b) ? 'true' : 'false');
      });
      garRaiz.querySelectorAll('[data-gar-d]').forEach(function (d) {
        d.classList.toggle('is-aberto', abrir && d.getAttribute('data-gar-d') === n);
      });
    });
  }

  /* ── TIRA DE MINI VÍDEOS ──────────────────────────────────────────────
     Escrito sobre a especificação da técnica, não copiado de lugar nenhum.

     A REGRA CENTRAL É "UM `<video>` NO DOM POR VEZ". Sete elementos vivos
     engasgam a rolagem no computador. Ao sair de ativa, a miniatura tem o
     vídeo REMOVIDO — pausar não devolve a memória nem a banda.

     A SEGUNDA REGRA É "SÓ RODA QUANDO ESTÁ NA TELA". Vídeo tocando fora do
     campo de visão é bateria e 4G do cliente jogados fora. */
  var avRaiz = caixa.querySelector('[data-cprav]');
  var avLb = document.querySelector('[data-cprav-lb]');
  if (avRaiz && avLb) {
    var avCards = [].slice.call(avRaiz.querySelectorAll('[data-cprav-card]'));
    var avVideo = avLb.querySelector('[data-cprav-video]');
    var avQuem = avLb.querySelector('[data-cprav-lb-quem]');
    var avReduz = window.matchMedia
      ? matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

    var avAtual = 0, avRelogio = null, avRodando = false, avAberto = -1, avVolta = null;

    /* A VAGA NA COLUNA É MEDIDA, NÃO CHUTADA. A coluna ordena os filhos por
       `order` numa folha que não está aqui pra ser lida. Copiando o número do
       vizinho de cima, o empate é desfeito pelo HTML — e a tira cai logo
       depois dele, antes do frete, em qualquer largura. */
    var avAcima = caixa.querySelector('.cpr-abaixo');
    if (avAcima) {
      var avVaga = function () {
        var o = getComputedStyle(avAcima).order;
        if (o && o !== 'auto') { avRaiz.style.order = o; }
      };
      avVaga();
      addEventListener('resize', avVaga, { passive: true });
    }

    var avLimpa = function (card) {
      var v = card && card.querySelector('video');
      if (v) { v.pause(); v.removeAttribute('src'); v.load(); v.remove(); }
    };

    /* CATRACA — 01/10 (Romulo). A fila rola inteira, sem nada sumir atrás
       de nada; a primeira vaga funciona como uma catraca: cada miniatura que
       passa por ela cresce até o tamanho de destaque e encolhe ao sair, quadro
       a quadro, no ritmo do dedo. O encaixe é o scroll-snap do navegador (todas
       têm a mesma largura no layout), uma por vez.
       Conta por cartão i, com s = rolagem ÷ passo:
         f = max(0, 1 − |i − s|)        quanto ele ocupa a vaga (0 a 1)
         escala = 1 + (A/l − 1) × f     origem na esquerda
         x = soma do que os anteriores cresceram   (empurra, não sobrepõe) */
    var avTrilho = avRaiz.querySelector('[data-cprav-trilho]');
    var avTrava = 0, avTocaT = null, avQuadro = 0;
    var avMed = function () {
      var cs = getComputedStyle(avRaiz);
      var l = parseFloat(cs.getPropertyValue('--av-l')) || 84;
      var pk = parseFloat(cs.getPropertyValue('--av-pk')) || 0;
      return { l: l, passo: l + 8, g: 1.2, pk: pk };   /* --av-a = l × 1.2 */
    };
    /* rolagem → posição na fila. A vaga fica pk depois da borda; o 1º não
       alcança essa folga, então o trecho inicial (0 a passo − pk) é esticado
       pra valer um cartão inteiro, sem degrau. */
    var avPos = function (m) {
      var x = avTrilho.scrollLeft, ini = m.passo - m.pk;
      return x <= ini ? x / ini : (x + m.pk) / m.passo;
    };
    var avDesenha = function () {
      if (!avTrilho) return;
      var m = avMed(), sPos = avPos(m), extra = 0;
      avCards.forEach(function (c, i) {
        var f = Math.max(0, 1 - Math.abs(i - sPos));
        c.style.setProperty('--av-x', extra.toFixed(2) + 'px');
        c.style.setProperty('--av-s', (1 + (m.g - 1) * f).toFixed(4));
        c.style.setProperty('--av-f', f.toFixed(3));
        extra += (m.g - 1) * m.l * f;
      });
    };
    var avRolaPara = function (n, suave) {
      if (!avTrilho) return;
      avTrava = Date.now() + 700;
      var m = avMed();
      avTrilho.scrollTo({ left: n ? n * m.passo - m.pk : 0, behavior: (suave && !avReduz.matches) ? 'smooth' : 'auto' });
    };

    var avToca = function () {
      clearTimeout(avTocaT);
      if (!avRodando || avAberto >= 0) return;
      var card = avCards[avAtual];
      if (!card || card.querySelector('video')) return;
      var v = document.createElement('video');
      v.muted = true;            /* som na miniatura faz o play() ser rejeitado */
      v.playsInline = true;
      v.setAttribute('playsinline', '');
      v.setAttribute('muted', '');
      v.preload = 'metadata';
      v.loop = avCards.length < 2;
      /* miniatura de ~100 px: a versao 480p da Shopify basta (um terco do 720p).
         Se a 480p falhar, volta pro endereco do campo. */
      var avU = card.getAttribute('data-src') || '';
      var avL = avU.replace(/HD-720p-(4\.5|3\.0|2\.1|1\.6)Mbps/, function (m, tx) {
        return 'SD-480p-' + ({ '4.5': '1.5', '3.0': '1.2', '2.1': '1.0', '1.6': '0.9' })[tx] + 'Mbps';
      });
      if (avL !== avU) v.addEventListener('error', function () { if (v.getAttribute('src') !== avU) v.src = avU; }, { once: true });
      v.src = avL;
      card.appendChild(v);
      if (avCards.length > 1) {
        v.addEventListener('ended', avAvanca, { once: true });
        clearTimeout(avRelogio);
        avRelogio = setTimeout(avAvanca, 15000);
        v.addEventListener('loadedmetadata', function () {
          clearTimeout(avRelogio);
          var d = v.duration;
          avRelogio = setTimeout(avAvanca, (isFinite(d) && d > 0 ? d * 1000 + 900 : 4500));
        }, { once: true });
      }
      var p = v.play();
      if (p && p.catch) { p.catch(function () {}); }
    };

    /* quem entra na vaga vira o destaque; o vídeo só começa quando a fila
       para, senão cada miniatura que passa abriria um download */
    var avAtiva = function (n) {
      avCards.forEach(function (c, k) {
        c.classList.toggle('na-vaga', k === n);
        if (k !== n) avLimpa(c);
      });
      clearTimeout(avTocaT);
      avTocaT = setTimeout(avToca, 260);
    };

    var avAvanca = function () {
      clearTimeout(avRelogio);
      if (!avRodando || avAberto >= 0 || avCards.length < 2) return;
      var prox = (avAtual + 1) % avCards.length;
      /* do último pro primeiro, sem desfilar a fila inteira */
      avRolaPara(prox, prox !== 0);
      avAtual = prox;
      avAtiva(prox);
    };

    if (avTrilho) {
      avTrilho.addEventListener('scroll', function () {
        var doDedo = Date.now() >= avTrava;
        if (doDedo) clearTimeout(avRelogio);   /* a pessoa está mexendo */
        if (avQuadro) return;
        avQuadro = requestAnimationFrame(function () {
          avQuadro = 0;
          avDesenha();
          var k = Math.round(avPos(avMed()));
          k = Math.max(0, Math.min(avCards.length - 1, k));
          if (k !== avAtual) {
            avAtual = k; avAtiva(k);
            /* o "clique" da catraca, só quando é o dedo que gira */
            if (doDedo && window.Tato && Tato.leve) { try { Tato.leve(); } catch (e) {} }
          }
        });
      }, { passive: true });
      addEventListener('resize', avDesenha, { passive: true });
      avDesenha();

      /* CATRACA FIRME — 02/10. O encaixe nativo às vezes não fecha (iOS
         depois de um arraste lento, ou um toque que interrompe o deslize
         automático) e a fila parava com dois vídeos dividindo a vaga.
         Quando a rolagem termina de verdade — dedo fora da tela e sem
         inércia — confere se a vaga está ocupada por inteiro; se não, leva
         até o cartão mais perto. */
      var avDedo = false, avFimT = null;
      var avAssenta = function () {
        if (avDedo || Date.now() < avTrava) return;
        var m = avMed();
        var k = Math.round(avPos(m));
        k = Math.max(0, Math.min(avCards.length - 1, k));
        var alvo = k ? k * m.passo - m.pk : 0;
        var max = avTrilho.scrollWidth - avTrilho.clientWidth;
        if (alvo > max) alvo = max;
        if (Math.abs(avTrilho.scrollLeft - alvo) > 1.5) {
          avTrava = Date.now() + 500;
          avTrilho.scrollTo({ left: alvo, behavior: avReduz.matches ? 'auto' : 'smooth' });
        }
        avDesenha();
      };
      var avFimDepois = function (ms) { clearTimeout(avFimT); avFimT = setTimeout(avAssenta, ms); };
      avTrilho.addEventListener('touchstart', function () { avDedo = true; clearTimeout(avFimT); }, { passive: true });
      avTrilho.addEventListener('touchend', function () { avDedo = false; avFimDepois(260); }, { passive: true });
      avTrilho.addEventListener('touchcancel', function () { avDedo = false; avFimDepois(260); }, { passive: true });
      if ('onscrollend' in window) {
        avTrilho.addEventListener('scrollend', function () { avFimDepois(40); });
      }
      /* sem scrollend (Safari antigo): a última rolagem + uma folga */
      avTrilho.addEventListener('scroll', function () { if (!avDedo) avFimDepois(180); }, { passive: true });
    }

    var avLiga = function () {
      if (avRodando || avReduz.matches || avAberto >= 0) return;
      avRodando = true;
      avToca();
    };

    var avDesliga = function () {
      avRodando = false;
      clearTimeout(avRelogio);
      clearTimeout(avTocaT);
      avCards.forEach(function (c) { avLimpa(c); });
    };

    /* ── o tocador ── */
    var avMostra = function (n) {
      avAberto = ((n % avCards.length) + avCards.length) % avCards.length;
      var card = avCards[avAberto];
      avVideo.src = card.getAttribute('data-src');
      avVideo.muted = false;     /* aqui pode: já houve gesto do usuário */
      avQuem.textContent = card.getAttribute('data-quem') || '';
      var p = avVideo.play();
      if (p && p.catch) { p.catch(function () {}); }
    };

    var avAbre = function (n) {
      avVolta = avCards[n] || null;
      avDesliga();
      avLb.hidden = false;
      /* um quadro entre `hidden` e a classe, senão a transição não acontece */
      requestAnimationFrame(function () { avLb.classList.add('aberto'); });
      document.documentElement.style.overflow = 'hidden';
      avMostra(n);
    };

    var avFecha = function () {
      avAberto = -1;
      avLb.classList.remove('aberto');
      avVideo.pause();
      avVideo.currentTime = 0;
      avVideo.removeAttribute('src');
      avVideo.load();
      document.documentElement.style.overflow = '';
      setTimeout(function () { avLb.hidden = true; }, 300);
      if (avVolta) { avVolta.focus(); avVolta = null; }
      avLiga();
    };

    avRaiz.addEventListener('click', function (e) {
      var card = e.target.closest('[data-cprav-card]');
      if (!card) return;
      var n = avCards.indexOf(card);
      if (n >= 0) { avAtual = n; avAbre(n); }
    });

    avLb.addEventListener('click', function (e) {
      if (e.target.closest('[data-cprav-fecha]')) { avFecha(); return; }
      if (e.target.closest('[data-cprav-ant]')) { avMostra(avAberto - 1); return; }
      if (e.target.closest('[data-cprav-prox]')) { avMostra(avAberto + 1); }
    });

    document.addEventListener('keydown', function (e) {
      if (avAberto < 0) return;
      if (e.key === 'Escape') { avFecha(); }
      else if (e.key === 'ArrowLeft') { avMostra(avAberto - 1); }
      else if (e.key === 'ArrowRight') { avMostra(avAberto + 1); }
    });

    avAtiva(0);   /* o primeiro já nasce em destaque */

    if (!avReduz.matches) {
      if (window.IntersectionObserver) {
        new IntersectionObserver(function (ents) {
          ents.forEach(function (en) { en.isIntersecting ? avLiga() : avDesliga(); });
        }, { threshold: 0.35 }).observe(avRaiz);
      } else {
        avLiga();
      }
      /* aba em segundo plano congela mídia: não adianta manter o ciclo */
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) { avDesliga(); }
      });
    }

    /* o editor redesenha a seção a cada tecla e leva a tira junto */
    document.addEventListener('shopify:section:unload', function (ev) {
      if (ev.target.contains(avRaiz)) {
        avDesliga();
        document.documentElement.style.overflow = '';
      }
    });
  }

})();
  }
  iniciar();
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('.spdp .buy.cpr, .buy.cpr')) iniciar();
  });
})();
